function App() {
  return <div style={{ textAlign: 'center' }}>This is a new wayeeux app.</div>;
}

export default App;
